import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-hot-toast";


import { 
  getAllEvents as getAllEventsApi,
  addEvent as addEventApi,
  getEventById as getEventByIdApi,
  getInHouseArtists as getInHouseArtistsApi,
  deleteEvent as deleteEventApi,
 } from "../../helpers/custom_helper/backend_helper";


 export const getAllEventsThunk = createAsyncThunk("get-all-events", async () => {
  try {
   
     const response = getAllEventsApi();
    const data = await response;
  

    if(data.success)
    {
      return response;
    }else {

        return response;
    }
  } catch (error) {
      return error;
  }
});
 export const getEventDetailsThunk = createAsyncThunk("get-event-detail", async (dataa) => {
  try {
   

    
   
     const response =await getEventByIdApi(dataa);
    const data = await response;
  

    if(data.success)
    {
      return response;
    }else {

        return response;
    }
  } catch (error) {
      return error;
  }
});
 export const getInhouseArtistsThunk = createAsyncThunk("get-inhouse-artists", async () => {
  try {
   

    
   
     const response =await getInHouseArtistsApi();
    const data = await response;
  

    if(data.success)
    {
      return response;
    }else {

        return response;
    }
  } catch (error) {
      return error;
  }
});
 export const delEventThunk = createAsyncThunk("delete-event", async (dataa) => {
  try {
   

    
   
     const response =await deleteEventApi(dataa);
    const data = await response;
  

    if(data.success)
    {
      return response;
    }else {

        return response;
    }
  } catch (error) {
      return error;
  }
});

//add event thunk
export const addEventThunk = createAsyncThunk( "addEvent",async (data, { rejectWithValue }) => {
    try {

      //we need to enable the loader here

      
      
      const response = await addEventApi(data);
      
      
    
   
      // console.log("Add Event Response:", response);
      if (response.success) {
        // toast.success("Event added successfully");
       
        return response.data;
      } else {
        toast.error(response.message );
        return rejectWithValue(response.message);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong");
      return rejectWithValue(error.message);
    }
  }
);














